/* import __COLOCATED_TEMPLATE__ from './new-oauth-token-modal.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import type Store from '@ember-data/store';
import { isPresent } from '@ember/utils';

interface Error {
  attribute: string;
  message: string;
  type: string;
}

interface Args {
  onModalClose: () => void;
  onCreate: () => Promise<void>;
}

export default class NewOauthTokenModal extends Component<Args> {
  @service declare appService: $TSFixMe;
  @service declare store: Store;

  @tracked tokenName = '';
  @tracked appPackageNameErrors?: Error[];

  get isCreateButtonDisabled() {
    return !isPresent(this.tokenName);
  }

  get tokenNameError() {
    return this.appPackageNameErrors?.firstObject?.message ?? '';
  }

  @action
  async createApiToken() {
    let appPackage = this.store.createRecord('developer-hub/app-package', {
      name: this.tokenName,
      ownerAppId: this.appService.app.id,
    });

    let nameErrors = appPackage.get('nameErrors');
    if (nameErrors.length) {
      this.appPackageNameErrors = nameErrors;
      appPackage.unloadRecord();
      return;
    }

    await appPackage.save();
    await this.args.onCreate();
    this.args.onModalClose();
  }

  private resetProperties() {
    this.tokenName = '';
    this.appPackageNameErrors = undefined;
  }

  @action
  onModalClose() {
    this.args.onModalClose();
    this.resetProperties();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Personal::NewOauthTokenModal': typeof NewOauthTokenModal;
    'new-settings/personal/new-oauth-token-modal': typeof NewOauthTokenModal;
  }
}
